import { disablePageScroll, enableScroll } from '../utils/scroll';

export default () => {
  const pointer = document.createElement('div');
  const tip = document.createElement('div');
  pointer.classList.add('mouse-pointer');
  tip.classList.add('mouse-pointer__tip');
  pointer.append(tip);
  document.body.append(pointer);
  document.documentElement.classList.add('hide-cursor');

  let mouseX = 0;
  let mouseY = 0;

  const moveCursor = (event)=> {
    mouseY = event.clientY;
    mouseX = event.clientX;

    pointer.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
  };

  window.addEventListener('mousemove', moveCursor);

  document.querySelectorAll('a:not([data-pointer-no-tip]):not(.link):not(.filter__btn), .play-video').forEach((anchor) => {
    anchor.addEventListener('mouseover', () => {
      pointer.classList.add('active');
    });
    anchor.addEventListener('mouseout', () => {
      pointer.classList.remove('active');
    });
  });
};
